import classNames from "classnames";
import React, { Fragment, useEffect, useState } from "react";
import FreeScrollBar from "react-free-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Container } from "reactstrap";
import { Loader } from "semantic-ui-react";
import { NavbarMain } from "./component/NavbarMain";
import { Sidebar } from "./component/Sidebar";
import { getDataAction } from "./config/redux/action";
import { KABUPATEN, KECAMATAN, KELURAHAN, PROVINSI } from "./constants";
import { isBiro } from "./utils/helper";
import Activity from "./pages/Activity";
import Akun from "./pages/Akun";
import Anggaran from "./pages/Anggaran";
import Approval from "./pages/Approval/Approval";
import DetailAnggaran from "./pages/Approval/DetailAnggaran";
import DetailArusKas from "./pages/Approval/DetailArusKas";
import DetailLabaRugi from "./pages/Approval/DetailLabaRugi";
import DetailNeraca from "./pages/Approval/DetailNeraca";
import AddBerita from "./pages/Berita/AddBerita";
import Berita from "./pages/Berita/Berita";
import EditBerita from "./pages/Berita/EditBerita";
import Dashboard from "./pages/Dashboard";
import { ViewDocumentPDF } from "./pages/Dashboard/ViewDocumentPDF";
import Document from "./pages/Document";
import EditPegawai from "./pages/EditPegawai";
import AddEvent from "./pages/Event/AddEvent";
import EditEvent from "./pages/Event/EditEvent";
import Event from "./pages/Event/Event";
import Financial from "./pages/Financial";
import AspekAdministrasi from "./pages/IndikatorKesehatan/AspekAdministrasi";
import AspekKeuangan from "./pages/IndikatorKesehatan/AspekKeuangan";
import AspekOperasional from "./pages/IndikatorKesehatan/AspekOperasional";
import IndikatorKesehatan from "./pages/IndikatorKesehatan/IndikatorKesehatan";
import Pegawai from "./pages/Pegawai";
import DaftarAset from "./pages/DaftarAset";
import DetailPegawai from "./pages/Pegawai/DetailPegawai";
import DetailDaftarAset from "./pages/DetailDaftarAset";
import EditDaftarAset from "./pages/EditDaftarAset";
import Perusahaan from "./pages/Perusahaan";
import Report from "./pages/Report";
import TambahPegawai from "./pages/TambahPegawai";
import TambahDaftarAset from "./pages/TambahDaftarAset";
import Deviden from "./pages/Deviden";
import Footer from "./component/Footer/Footer";

export const Main = (props) => {
  let history = useHistory();
  let { path, url } = useRouteMatch();
  const [isOpenSidebar, setOpenSidebar] = useState(true);
  const toggleSidebar = () => setOpenSidebar(!isOpenSidebar);
  const user = useSelector((state) => state.main.dataUser);
  const dispatch = useDispatch();

  const initArea = () => {
    const areas = [
      { path: "provinsi", type: PROVINSI, local: true },
      { path: "kabupaten", type: KABUPATEN, local: true },
      { path: "kecamatan", type: KECAMATAN, local: true },
      { path: "kelurahan", type: KELURAHAN, local: true },
    ];
    areas.forEach((a) => dispatch(getDataAction(a)));
  };

  useEffect(() => {
    // initArea();
    dispatch({
      type: "GET_DATA_USER",
      data: JSON.parse(localStorage.getItem("user")),
    });
  }, []);

  useEffect(() => {
    if (user) {
      if (user.role < 4) {
        dispatch(
          getDataAction({
            path: `perusahaan?sort=nama,ASC&size=300`,
            type: "GET_DATA_PERUSAHAAN",
          })
        );
      }
    }
  }, [user]);

  if (!user) {
    return (
      <div className="w-100 d-flex justify-content-center">
        <Loader active>Loading</Loader>
      </div>
    );
  }

  return (
    <Fragment>
      <Sidebar isOpen={isOpenSidebar} toggle={toggleSidebar} {...props} />
      <div
        className={classNames("p-0 w-100", {
          "d-none d-md-block": isOpenSidebar,
        })}
      >
        <NavbarMain toggle={toggleSidebar} {...props} />
        <FreeScrollBar autohide style={{ width: "100%", height: "90%", }}>
          <div style={{
            position: 'relative',
            minHeight: '100vh',
            paddingBottom: '500px'
          }}>
            <Container fluid className={classNames("p-0", { "is-open": isOpenSidebar })}>
              <Switch>
                <Route exact path="/">
                  <Dashboard url={url} />
                </Route>
                <Route path="/berita" exact>
                  <Berita url={url} />
                </Route>
                <Route path="/berita/add" exact>
                  <AddBerita url={url} />
                </Route>
                <Route path="/berita/edit" exact>
                  <EditBerita url={url} />
                </Route>
                <Route path="/event" exact>
                  <Event url={url} />
                </Route>
                <Route path="/event/add" exact>
                  <AddEvent url={url} />
                </Route>
                <Route path="/event/edit" exact>
                  <EditEvent url={url} />
                </Route>
                <Route exact path="/viewdocument">
                  <ViewDocumentPDF url={url} />
                </Route>
                <Route path={`/report`}>
                  <Report url={url} />
                </Route>
                <Route path={`/deviden`}>
                  <Deviden url={url} />
                </Route>
                <Route path={`/anggaran`}>
                  <Anggaran url={url} />
                </Route>
                <Route path="/aspek-keuangan">
                  <AspekKeuangan url={url} />
                </Route>
                <Route path="/aspek-operasional">
                  <AspekOperasional url={url} />
                </Route>
                <Route path="/aspek-administrasi">
                  <AspekAdministrasi url={url} />
                </Route>
                <Route path="/indikator-kesehatan">
                  <IndikatorKesehatan url={url} />
                </Route>
                <Route path={`/approval`} exact={true}>
                  <Approval url={url} />
                </Route>
                <Route path={`/approval/anggaran/detail`} exact={true}>
                  <DetailAnggaran url={url} />
                </Route>
                <Route path={`/approval/arus-kas/detail`} exact={true}>
                  <DetailArusKas url={url} />
                </Route>
                <Route path={`/approval/laba-rugi/detail`} exact={true}>
                  <DetailLabaRugi url={url} />
                </Route>
                <Route path={`/approval/neraca/detail`} exact={true}>
                  <DetailNeraca url={url} />
                </Route>
                <Route path={`/financial-statement`}>
                  <Financial url={url} />
                </Route>
                <Route exact path={`/pegawai`}>
                  <Pegawai url={url} history={history} />
                </Route>
                <Route exact path={`/pegawai/detail/:idPegawai`}>
                  <DetailPegawai url={url} />
                </Route>
                <Route exact path={`/pegawai/edit/:idPegawai`}>
                  <EditPegawai url={url} />
                </Route>
                <Route exact path={`/daftar-aset`}>
                  <DaftarAset url={url} history={history} />
                </Route>
                <Route exact path={`/daftar-aset/detail/:idDaftarAset`}>
                  <DetailDaftarAset url={url} />
                </Route>
                <Route exact path={`/daftar-aset/edit/:idDaftarAset`}>
                  <EditDaftarAset url={url} />
                </Route>
                <Route path={`/daftar-aset/tambah`}>
                  <TambahDaftarAset url={url} />
                </Route>
                {isBiro() && (
                  <Route path={`/akun`}>
                    <Akun url={url} />
                  </Route>
                )}
                <Route path={`/activity`}>
                  <Activity url={url} />
                </Route>
              </Switch>
              <Switch>
                {user.role < 4 ? (
                  <>
                    <Route path={`/perusahaan`}>
                      <Perusahaan url={url} />
                    </Route>
                  </>
                ) : (
                  <>
                    <Route path={`/pegawai/tambah`}>
                      <TambahPegawai url={url} />
                    </Route>
                    <Route path={`/document`}>
                      <Document url={url} />
                    </Route>
                  </>
                )}
              </Switch>
              <ToastContainer />
            </Container>
            <Footer />
          </div>

        </FreeScrollBar>

      </div>

    </Fragment>
  );
};
